import {updatePageSize} from "./page";
import {scrollRuler, updateRuler, setOffsets, rulerIsToggled} from "./page-ruler";
import store from "../store";
import util, {getFillZoom, getFitZoom} from "../util";
import $ from "jquery";
import MenuObject from "./menu-object";
import constants from "../constants";
import * as actions from "../actions";
import Interactable from "./interactable";
import {updatePageBars} from "./selection";
import { wrapToCurve } from "./word-art";

const {updateZoom, setMinZoom, setMaxZoom, setZoomAdjusted} = actions;

export function setZoom(zoom) {
  util.getActiveDimensions().updateZoom(zoom);
  updatePageSize();
  updateRuler();

  const $selected = store.getState().$element;
  util.nextTick(() => {
    $('.menu-object').each(function () {
      const $this = $(this);
      const reselect = $selected && $selected[0] === $this[0];
      MenuObject.setHeights($this, {reselect});
    });
  });
}

export function setRevisionZoom(zoom) {
  const {dispatch} = store;
  const $pages = $('#pages');
  const transformOrigin = 'center top 0px';

  dispatch(updateZoom(zoom));
  $pages.css({
    'transform-origin': transformOrigin,
    '-webkit-transform-origin': transformOrigin,
  });

  $pages.css('transform', 'scale(' + zoom / 100 + ')');
}

export function fitRevisionToPage() {
  const $preview = $('#preview-pages');
  $preview.attr('style', $('#pages').attr('style'));
  $preview.css('display', 'block');
}

export function fitToPage(fullscreen = false, options = {fromPA: false}) {
  const {dispatch} = store;
  const $canvas = $('#canvas');
  const {isMobileVersion} = store.getState();

  if (constants.SCALED_ZOOM_APPROACH || constants.ZUM_ZOOM_APPROACH) {
    dispatch(updateZoom(100));
    setZoom(100);

    if (constants.ZUM_ZOOM_APPROACH) {
      $('#pages').css('zoom', '');
    } else {
      $canvas.css('height', '');
      $canvas.css('width', '');
      $('#pages').css({
        'transform': '',
        'margin-top': '',
        'height': 'auto'
      });
      $('.add-page-wrap').css({'top': '', 'bottom': ''});
    }

    const pageSize = util.getActiveDimensions();
    $(window).scrollLeft(0);

    const newZoom = getCalculatedZoom();
    dispatch(updateZoom(newZoom));

    const roundedZoom = util.roundToZoomStep(newZoom);
    const fillZoom = getFillZoom();
    const fitZoom = getFitZoom();

    let newMinZoom = constants.zoomSteps[constants.zoomSteps.indexOf(roundedZoom)-3];
    if (!newMinZoom) newMinZoom = constants.zoomSteps[0];
    let newMaxZoom = constants.zoomSteps[constants.zoomSteps.indexOf(roundedZoom)+5];
    if (!newMaxZoom) newMaxZoom = constants.zoomSteps[constants.zoomSteps.length - 1];

    if (fillZoom > fitZoom) {
      if (newMaxZoom < fillZoom) {
        newMaxZoom = util.roundToZoomStep(fillZoom);
      }
      if (newMinZoom > fitZoom) {
        newMinZoom = util.roundToZoomStep(fitZoom, true);
      }
    } else {
      if (newMaxZoom < fitZoom) {
        newMaxZoom = util.roundToZoomStep(fitZoom);
      }
      if (newMinZoom > fillZoom) {
        newMinZoom = util.roundToZoomStep(fillZoom, true);
      }
    }

    dispatch(setMinZoom(newMinZoom));
    dispatch(setMaxZoom(newMaxZoom));
    dispatch(setZoomAdjusted(roundedZoom));

    if (constants.SCALED_ZOOM_APPROACH) {
      const transformOrigin = (constants.SCALED_ZOOM_APPROACH_TOP_LEFT || isMobileVersion) ? 'left top 0px' : 'center top 0px';
      const $pages = $('#pages');
      $pages.css({
        'transform-origin': transformOrigin,
        '-webkit-transform-origin': transformOrigin
      });

      $pages.css('transform', 'scale(' + newZoom / 100 + ')');
      afterZoomReposition()
    } else {
      setZoom(newZoom);
    }

    let scroll = 0;

    const $page = $('#page-1');
    if ($page.length === 0) {
      return false;
    }
    let pageBox = $page.get(0).getBoundingClientRect();

    const pageX = pageBox.x;
    let leftSideWidth = $('#app-aside').width();
    let leftSideRequiredWidth = leftSideWidth + 50;

    if ((pageSize.width > pageSize.height) && pageX > leftSideRequiredWidth) {
      scroll = pageX - leftSideWidth - 25;
      $(window).scrollLeft(scroll);
    }

    $(window).scrollTop($('#' + util.getFirstVisiblePage()).offset().top - 125);
    return false;
  }

  const $window = $(window);
  const windowHeight = $window.height();
  const windowWidth = $window.width();
  const canvasTop = $canvas.offset().top;

  const dims = util.getActiveDimensions();

  const availableHeight = (fullscreen ? windowHeight : (windowHeight - canvasTop - 100)) * 0.9;
  let availableWidth = (fullscreen ? windowWidth : $canvas.width()) * 0.9;

  if (options.fromPA) {
    availableWidth = availableWidth - 640;
  }

  let newZoomOnWidth = util.roundToZoomStep(availableWidth * 100 / dims.size.widthInPixels);
  let newZoom = util.roundToZoomStep(availableHeight * 100 / dims.size.heightInPixels);

  if (options.fromPA) {
    const pageBB = $('#page-1').get(0).getBoundingClientRect();
    if (pageBB.width > pageBB.height) {
      newZoom = newZoomOnWidth;
    }
  }

  const maxZoom = store.getState().maxZoom;
  const minZoom = store.getState().minZoom;
  if (newZoom > maxZoom) newZoom = maxZoom;
  if (newZoom < minZoom) newZoom = minZoom;

  dispatch(updateZoom(newZoom));
  setZoom(newZoom);

  if (options.fromPA) {
    util.nextTick(() => {
      util.positionPrintAdvisor();
    });
  }
}

export function afterZoomReposition(isFill) {
  const $pages = $('#pages');
  const $canvas = $('#canvas');

  $pages.css({'margin-top': '', 'height': 'auto'});
  $canvas.css({'width': ''});

  $pages.css({
    'margin-top': '',
    'height': 'auto',
    'margin-left': '',
    'width': ''
  });

  $canvas.css({'width': ''});

  util.nextTick(() => {
    let pagesDimensions = $pages.get(0).getBoundingClientRect();
    if ($pages.is(':hidden')) {
      pagesDimensions = $('#preview-pages').get(0).getBoundingClientRect();
    }

    const canvasBrowserWidth = $canvas.width();
    const pageSize = util.getActiveDimensions();
    const zoom = store.getState().zoom / 100;

    const panelWidth = 18;
    const panelScale = panelWidth / (18 * store.getState().zoom / 100);

    let bottom = '10px';
    let right = '-30px';
    if (zoom < 1) {
      bottom = '30px';
    }

    if (zoom < 0.6) {
      if (pageSize.height > 200) {
        bottom = '90px';
      }
      right = '-40px';
    }

    if (zoom <= 0.4) {
      if (pageSize.height > 450) {
        bottom = '250px';
        right = '-70px';
      }
    }
    let styles = '.panel, .res-left, .res-right, .res-top, .res-btm, .btm-right, .btm-left, .top-right, .top-left, .rotate-handler {transform : scale(' + panelScale + ') !important}';
    styles += '.panel {bottom : ' + bottom + ' !important; right : ' + right + ' !important}';
    if (store.getState().isMobileVersion) {
      styles += '.panel {transform: scale(' + .85 * panelScale + ') !important}';
    }

    let $zoomPatch = $('#zoomPatch');
    if ($zoomPatch.length === 0) {
      $zoomPatch = $('<div id="zoomPatch"/>');
      $('body').append($zoomPatch);
    }

    $zoomPatch.empty();

    const $style = $('<style>');
    $style.text(styles);
    $zoomPatch.append($style);

    if (pageSize.key === 'fb-story' || pageSize.key === 'insta-story' || pageSize.key === 'poster' || pageSize.key === 'sandwich-board') {
      if (!isFill && zoom <= 1.45 && pageSize.width > 1080) {
        let browserPagesWidth = $('#pages').width() * zoom;
        let browserPageOneWidth = $('#page-1').width() * zoom;
        if (browserPageOneWidth < canvasBrowserWidth && browserPagesWidth < browserPageOneWidth) {
          const pagesMarginLeft = browserPagesWidth - browserPageOneWidth + panelWidth + 10;
          $pages.css({'margin-left': pagesMarginLeft + 'px'});
        } else {
          if (browserPageOneWidth > canvasBrowserWidth) {
            const pagesMarginLeft = (browserPagesWidth - browserPageOneWidth) / 2;
            $pages.css({'margin-left': pagesMarginLeft + 'px'});
          } else {
            $pages.css({'margin-left': ''});
          }
        }
      } else {
        $pages.css({'margin-left': ''});
      }
    } else {
      $pages.css({'margin-left': ''});
    }

    if (store.getState().zoom < 100) {
      $pages.css({'height': (pagesDimensions.height + 150) + 'px'});
    }

    $canvas.css({'height': (pagesDimensions.height + 150) + 'px'});

    if (util.isEdge()) {
      $canvas.css({'overflow': store.getState().zoom < 85 ? 'hidden' : 'inherit'});
    } else {
      $canvas.css({'overflow': 'inherit'});
    }

    $('[data-component="text"][data-text-wrapped="true"]').each(function() {
      wrapToCurve($(this));
    })

    if (rulerIsToggled()) {
      setOffsets();
      scrollRuler();
    }
    Interactable.refreshControls();
    Interactable.refreshPageNumber();
    util.nextTick(() => {
      window['refreshMOModal']?.();
    }, 5);
  });
  const $selected = store.getState().$element;
  if ($selected && $selected.length) {
    updatePageBars($selected);
  }
}

export function getCalculatedZoom() {
  const {isMobileVersion} = store.getState();
  const pageSize = util.getActiveDimensions();

  let height = pageSize.height;
  if (pageSize.key === 'gift-certificate-landscape') {
    height = height * 1.25;
  }

  let newZoom = 1;
  if (isMobileVersion) {
    newZoom = parseInt(`${($(window).width() - 10) / pageSize.width * 100}`, 10);
    if (newZoom > 100) newZoom = 100
  } else {
    const availableHeight = $(window.top).height() - 150;
    newZoom = parseInt(`${availableHeight / height * 100}`, 10)
  }

  return newZoom;
}
